export const getContactSettingOptions = (
  t,
  objectSettingsAccess,
  objectSettingsMenuItems = []
) =>
  [
    {
      value: 'contactSettings',
      label: t('Object Settings'),
    },
    objectSettingsAccess.customize_fields.edit && {
      value: 'customizeFields',
      label: t('Customize Fields'),
    },
    {
      value: 'history',
      label: t('Object History'),
    },
    {
      value: 'viewApiDocs',
      label: t('View API Docs'),
    },
    ...objectSettingsMenuItems.map((item) => {
      return {
        value: `${item.plugin_api_name}-${item.api_name}`,
        label: item.label,
        scriptConfig: item,
      };
    }),
  ].filter(Boolean);
